'use client';

import { Box, useMatches } from '@mantine/core';
import { useIsAuthenticated } from '@/src/modules/auth/hooks/use-is-authenticated';
import { BannerAd } from '@/src/shared/components/index/Home/BannerAd';
import { CategoryGrid } from '@/src/shared/components/index/Home/CategoryGrid';
import { HomeGrid } from '@/src/shared/components/index/Home/HomeGrid';
import { useGeolocation } from '@/src/shared/hooks/useGeolocation';
import { ChatPopup } from './chat/_components/ui/chat-popup/chat-popup';

export default function Home() {
  useGeolocation();
  const isAuthenticated = useIsAuthenticated();
  const isMobileView = useMatches({ base: true, md: false });

  return (
    <Box pos="relative">
      <BannerAd />
      <CategoryGrid />
      <HomeGrid />
      {/* <PharmacyGrid /> */}

      {isAuthenticated && !isMobileView && <ChatPopup />}
    </Box>
  );
}
